<template>
    <div @touchstart.stop.prevent="touchStart($event)" @touchmove.stop.prevent="touchMove($event)" @touchend.stop.prevent="touchEnd($event)" ref="container">
        <div style=" transform:translateY(50px)" :style="{ transform: 'translateY(' + transformY + 'px)', transition: isAnimating ? 'transform 0.2s linear' : '' }">
            <div class="each_row" v-for="each, i in list" :key="i" :class="[curIndex === i ? 'active' : '', curIndex + 1 === i ? 'upAndDown' : '', curIndex - 1 === i ? 'upAndDown' : '']" style="line-height:30px;" :style="{ height: height + 'px' }" @click="touchLabel(i)">{{ each.label }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ScrollSelector",
    props: {
        list: {
            type: Array,
            default: () => []
        },
        initValue: {
            type: String,
            default: '',
        },
        detectValueChange: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            curIndex: -1,
            startY: 0,
            transformY: 0,
            lastTransformY: 0,
            yMoves: [],
            height: 30,
            containerHeight: 0,
            halfContainerHeight: 0,
            isAnimating: false,
            diff_y: 0,
        }
    },
    watch: {
        initValue() {
            console.log('initValue changed');
            this.refreshCenter();
        }
    },
    methods: {
        touchStart(e) {
            this.startY = e.touches[0].pageY;
        },
        touchMove(e) {
            const curY = e.touches[0].pageY;
            const diffY = (curY - this.startY);
            this.diff_y = diffY;
            this.transformY = this.lastTransformY + parseInt(diffY);
            this.yMoves.push(curY);
        },
        touchEnd() {
            if (this.transformY > this.halfContainerHeight) {
                this.yMoves = [];
                this.setCenterAnimated(0);
                return;
            }

            // console.log(this.transformY, this.list.length * this.height - this.halfContainerHeight);
            // 30분단위 scroll 리셋
            if (this.transformY < 56 && this.list.length === 2) {
                this.yMoves = [];
                this.setCenterAnimated(this.list.length - 1);
                return
            }

            if ((this.transformY < 0 && Math.abs(this.transformY) > Math.abs(this.list.length * this.height - this.halfContainerHeight))) {
                this.yMoves = [];
                this.setCenterAnimated(this.list.length - 1);
                return;
            }

            this.lastTransformY = parseInt(this.transformY);
            const totalMovesCnt = this.yMoves.length;
            if (totalMovesCnt > 7) {
                const accelerationFactor = this.yMoves[totalMovesCnt - 1] - this.yMoves[totalMovesCnt - 6];
                const abs_factor = Math.abs(accelerationFactor)
                if(abs_factor > 120) {
                    const target_index = accelerationFactor > 0 ? 0 : this.list.length - 1;
                    this.setCenterAnimated(target_index)
                }else if(abs_factor > 100){
                    const diff_index = 50;
                    const target_index = accelerationFactor > 0 ? Math.max(0, this.curIndex - diff_index) : Math.min(this.list.length - 1, this.curIndex + diff_index) ;
                    this.setCenterAnimated(target_index)
                }else if(abs_factor > 80){
                    const diff_index = 30;
                    const target_index = accelerationFactor > 0 ? Math.max(0, this.curIndex - diff_index) : Math.min(this.list.length - 1, this.curIndex + diff_index) ;
                    this.setCenterAnimated(target_index)
                }else if(abs_factor > 60){
                    const diff_index = 20;
                    const target_index = accelerationFactor > 0 ? Math.max(0, this.curIndex - diff_index) : Math.min(this.list.length - 1, this.curIndex + diff_index) ;
                    this.setCenterAnimated(target_index)
                }else if(abs_factor > 40){
                    const diff_index = 15;
                    const target_index = accelerationFactor > 0 ? Math.max(0, this.curIndex - diff_index) : Math.min(this.list.length - 1, this.curIndex + diff_index) ;
                    this.setCenterAnimated(target_index)
                } else if (abs_factor > 20) {
                    const diff_index = 10;
                    const target_index = accelerationFactor > 0 ? Math.max(0, this.curIndex - diff_index) : Math.min(this.list.length - 1, this.curIndex + diff_index) ;
                    this.setCenterAnimated(target_index)
                } else {
                    this.fitLocation();
                }
            } else {
                this.fitLocation();
            }

            this.yMoves = [];
        },
        fitLocation() {
            this.setCenterAnimated(parseInt((this.halfContainerHeight - this.transformY) / this.height));
        },
        setCenterAnimated(index) {
            this.isAnimating = true;
            this.$nextTick(() => {
                this.setCenter(index);
                setTimeout(() => {
                    this.isAnimating = false;
                }, 200)
            });
        },
        setCenter(index) {
            const transformY = this.containerHeight * 0.5 - index * this.height - this.height * 0.5;
            this.curIndex = index;
            this.transformY = transformY;
            this.lastTransformY = transformY;
            this.detectValueChange(this.list[index]);
        },
        touchLabel(index) {
            if (Math.abs(this.diff_y) < 10) {
                this.setCenterAnimated(index);
            }
        },
        refreshCenter() {
            this.containerHeight = this.$refs.container.offsetHeight;
            this.halfContainerHeight = this.$refs.container.offsetHeight * 0.5;

            let index = 0;
            const findindex = this.list.findIndex((each) => each.value === this.initValue);
            if (findindex > -1)
                index = findindex;

            this.setCenter(index);
        }
    },
    mounted() {
        this.refreshCenter();
    },
    created() {

    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family)
}

.each_row {
    font-size: 16px;
    text-align: center;
    color: #cccccc;
}

.each_row.active {
    font-weight: 500;
    color: #606060;
}

.each_row.upAndDown {
    color: #aaaaaa
}
</style>